import { Link as RouterLink, useParams } from 'react-router-dom';

// material-ui
import { Link } from '@mui/material';

// project imports
import { DASHBOARD_PATH } from 'config';
import axios from 'axios';
import { useEffect, useState } from 'react';

// ==============================|| MAIN LOGO ||============================== //

const LogoSection = () => {
    const [instituteLogo, setInstituteLogo] = useState('');
    const { instituteId } = useParams();
    const role = localStorage.getItem('role');
    const userType = localStorage.getItem('userTypes');
    const instituteID = localStorage.getItem('instituteId');

    const downloadDocumentFunction = (fileName) => {
        axios
            .post(
                `/v1/utils/file/download`,
                { fileName },
                {
                    headers: {
                        Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then((result) => {
                setInstituteLogo(result.data.data);
            });
    };

    const getInstituteHeader = () => {
        axios
            .get(`/v1/institutes/get?instituteId=${instituteId === undefined ? instituteID : instituteId}`, {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem('serviceToken')}`,
                    'Content-Type': 'application/json'
                }
            })
            .then((result) => {
                if (userType !== 'EXTERNAL_CLIENT') {
                    downloadDocumentFunction(result.data.data.instituteLogo);
                } else {
                    downloadDocumentFunction(result.data.data.externalClientHeader);
                }
            });
    };

    useEffect(() => {
        getInstituteHeader();
    }, []);
    return (
        <>
            <Link component={RouterLink} to={DASHBOARD_PATH}>
                <div style={{ padding: 2, backgroundColor: '#00326d' }}>
                    <img
                        src={
                            role === 'ROLE_SUPER_ADMIN' && userType !== 'EXTERNAL_CLIENT'
                                ? '/assets/images/icons/ustm-logo_T.svg'
                                : instituteLogo
                        }
                        alt="t"
                        height="50%"
                        width="100%"
                    />
                </div>
            </Link>
        </>
    );
};

export default LogoSection;
